/* eslint-disable react/prop-types */
import React from 'react';
import { clsx as cx } from 'clsx';

const transitionDuration = '300ms';

export const Container = ({ children, isOpen, className, style, ...props }) => (
	<div
		className={cx('relative w-full h-full overflow-hidden', isOpen ? 'pointer-events-auto' : 'pointer-events-none', className)}
		style={{
			backgroundColor: isOpen ? 'rgba(0, 0, 0, 0.75)' : 'rgba(0, 0, 0, 0)',
			transition: `background-color ${transitionDuration} ease`,
			...style
		}}
		{...props}
	>
		{children}
	</div>
);

export const Overlay = ({ isOpen, className, ...props }) => (
	<div
		className={cx('absolute top-0 left-0 h-full w-full', isOpen ? 'pointer-events-auto' : 'pointer-events-none', className)}
		{...props}
	/>
);

export const MenuContainer = ({ children, isOpen, className, style, ...props }) => (
	<div
		className={cx(
			'absolute top-0 bottom-0 grid h-screen bg-midnight-100 outline-none',
			className
		)}
		style={{
			gridTemplateRows: 'auto 1fr',
			maxWidth: '40rem',
			width: '100%',
			left: isOpen ? '0' : 'calc(-40rem - 9px)',
			transition: `left ${transitionDuration} cubic-bezier(0.86, 0.01, 0.77, 0.78)`,
			boxShadow: '3px 0 6px 0 rgba(0, 0, 0, 0.5)',
			...style
		}}
		{...props}
	>
		{children}
	</div>
);

export const Header = ({ children, className, ...props }) => (
	<header className={cx('px-6 pt-6', className)} {...props}>
		{children}
	</header>
);

export const FiltersContainer = ({ children, className, ...props }) => (
	<div className={cx('mb-5 flex items-center justify-between pt-4', className)} {...props}>
		{children}
	</div>
);

export const CheckboxLabel = ({ children, className, ...props }) => (
	<span className={cx('ml-2', className)} {...props}>{children}</span>
);

export const Prompt = ({ children, className, ...props }) => (
	<div
		className={cx(
			'grid items-start gap-3 mt-3 mb-4 rounded-xs border border-border bg-midnight-100 px-4 py-3.5',
			className
		)}
		style={{ gridTemplateColumns: 'auto 1fr auto' }}
		{...props}
	>
		{children}
	</div>
);

export const PromptBody = ({ children, className, ...props }) => (
	<div className={cx('flex flex-col items-start gap-2', className)} {...props}>
		{children}
	</div>
);

export const PromptTitle = ({ children, className, ...props }) => (
	<span className={cx('font-bold leading-tight', className)} {...props}>{children}</span>
);

export const PromptText = ({ children, className, ...props }) => (
	<p className={cx('m-0 text-sm leading-snug text-muted-foreground', className)} {...props}>{children}</p>
);

export const PromptDismiss = ({ children, className, ...props }) => (
	<button
		type="button"
		className={cx(
			'cursor-pointer border-0 bg-transparent p-1 leading-none text-muted-foreground transition-colors hover:text-foreground',
			className
		)}
		{...props}
	>
		{children}
	</button>
);
